import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("proppa_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("proppa_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, openDrawer = true) => {
    setItems((prev) => {
      const found = prev.find((i) => i.lookup_key === product.lookup_key);
      if (found) {
        return prev.map((i) =>
          i.lookup_key === product.lookup_key ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    if (openDrawer) setOpen(true);
  };

  const setQuantity = (lookup_key, quantity) => {
    if (quantity <= 0) {
      setItems((prev) => prev.filter((i) => i.lookup_key !== lookup_key));
      return;
    }
    setItems((prev) => prev.map((i) => (i.lookup_key === lookup_key ? { ...i, quantity } : i)));
  };

  const removeItem = (lookup_key) =>
    setItems((prev) => prev.filter((i) => i.lookup_key !== lookup_key));

  const clearCart = () => setItems([]);

  const { subtotal, count } = useMemo(() => {
    return {
      subtotal: items.reduce((sum, i) => sum + i.price_pence * i.quantity, 0),
      count: items.reduce((sum, i) => sum + i.quantity, 0),
    };
  }, [items]);

  return (
    <CartContext.Provider
      value={{ items, addItem, setQuantity, removeItem, clearCart, subtotal, count, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
